<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="Status">Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="rateDate" inputId="rateDate" appendTo="body">
            </p-calendar>
            <label for="rateDate">Rate Date</label>
            @for (validation of validationMessages.rateDate; track validation) {
              <span>
                @if (form1.get('rateDate').hasError(validation.type) && (form1.get('rateDate').dirty || form1.get('rateDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <h6 for="isRate">Rate Options</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['isRate']" inputId="isRate" [binary]="true"></p-checkbox>
            <span class="rate-nm">Is Rate?</span>
          </div>
          @for (validation of validationMessages.isRate; track validation) {
            <span>
              @if (form1.get('isRate').hasError(validation.type) && (form1.get('isRate').dirty || form1.get('isRate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (rateId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!rateId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (rateId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>